import { __assign, __extends } from "tslib";
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Languages } from "../../constants/languages";
import { ITranslations } from "../../models/translations";
import "../../../style/components/contentWithCopy.scss";
import { chalk } from "../../../style/highlighterThemes/chalk";
var ContentWithCopy = (function (_super) {
    __extends(ContentWithCopy, _super);
    function ContentWithCopy(props) {
        var _this = _super.call(this, props) || this;
        _this.renderContentToCopy = function () {
            var _a = _this.props, body = _a.body, language = _a.language;
            if (!body) {
                return null;
            }
            return (React.createElement(SyntaxHighlighter, { language: language, style: chalk }, body));
        };
        _this.renderCopyButton = function () {
            var justCopiedToClipboard = _this.state.justCopiedToClipboard;
            var _a = _this.props, body = _a.body, t = _a.t;
            if (!body) {
                return null;
            }
            if (justCopiedToClipboard) {
                return React.createElement("div", { className: 'alert alert-success' }, t.copiedToClipboardMessage);
            }
            return (React.createElement(CopyToClipboard, { text: body },
                React.createElement("a", { className: 'btn rb-btn-small rb-btn-crimson', onClick: _this.onCopyClick }, t.copyToClipboardButton)));
        };
        _this.onCopyClick = function () {
            _this.setState(__assign(__assign({}, _this.state), { justCopiedToClipboard: true }));
            clearTimeout(_this.successMessageTimeout);
            _this.successMessageTimeout = setTimeout(function () {
                _this.setState(__assign(__assign({}, _this.state), { justCopiedToClipboard: false }));
            }, 3000);
        };
        _this.state = {
            justCopiedToClipboard: false,
        };
        return _this;
    }
    ContentWithCopy.prototype.componentWillUnmount = function () {
        clearTimeout(this.successMessageTimeout);
    };
    ContentWithCopy.prototype.render = function () {
        var body = this.props.body;
        if (!body) {
            return null;
        }
        return (React.createElement("div", { className: 'rb-content-with-copy-container' },
            React.createElement("div", { className: 'rb-content-with-copy' }, this.renderContentToCopy()),
            React.createElement("div", { className: 'rb-btn-container' }, this.renderCopyButton())));
    };
    return ContentWithCopy;
}(React.PureComponent));
export { ContentWithCopy };
